module.exports = __webpack_public_path__ + "img/hired.3f083100.svg";